<div class="w-100">
    <mwp-card-content-header [url]="apiUrl" />
    <mwp-table [tableColumns]="annualStatementsColumns" [dataSource]="annualStatementsMatTableData" header='Annual Statement Selection' (emitButtonSelection)="emailDocument($event)" (emitButtonSelection2)="DownloadFile($event)" />
</div>